import { z } from 'zod';
import { ReleaseLevel } from '@/features/stacktrace/productions/-query/type';
const releaseLevelValues = Object.values(ReleaseLevel) as [ReleaseLevel, ...ReleaseLevel[]];

/**
 * リリース判定 対象 Production 選択画面の URL search スキーマ。
 *
 * - freeText:      プロダクション名 / プロダクト名の部分一致検索
 * - statuses:      ステータス絞り込み（PLANNED / IN_PROGRESS。未指定は両方）
 * - releaseLevels: リリースレベルの複数選択フィルタ（空配列は全レベル）
 * - page / pageSize: ページネーション
 */
export const productionTargetsSearchSchema = z.object({
  page: z.coerce.number().min(1).optional().default(1),
  pageSize: z.coerce.number().min(1).optional().default(100),
  freeText: z.string().optional(),
  statuses: z.array(z.enum(['PLANNED', 'IN_PROGRESS'])).optional(),
  releaseLevels: z.array(z.enum(releaseLevelValues)).optional()
});
export type ProductionTargetsSearch = z.infer<typeof productionTargetsSearchSchema>;